import cnContent from "./token/en/cn.js";
import usContent from "./token/en/us.js";
import jpContent from "./token/en/jp.js";
import koContent from "./token/en/ko.js";
import geContent from "./token/en/ge.js";
import ukContent from "./token/en/uk.js";
import uaeContent from "./token/en/uae.js";
import frContent from "./token/en/fr.js";
import sgContent from "./token/en/sg.js";

import agreementContent from "./agreement/en-us.js";

export default {
  "head.index": "Home",
  "head.product": "Products",
  "head.computeProduct": "Compute Products",
  "head.computeProductDesc":
    "Purchase compute value and earn global compute returns",
  "head.rentalProduct": "Rental Products",
  "head.rentalProductDesc": "Rent high-performance servers for stable returns",
  "head.rental": "Rental",
  "head.about": "About Us",

  // ===== User Dropdown Menu =====
  "menu.profile": "Profile",
  "menu.security": "Account Security",
  "menu.settings": "Settings",
  "menu.products": "My Products",
  "menu.deposits": "Deposit Records",
  "menu.withdraws": "Withdrawal Records",
  "menu.walletLog": "Transaction Records",
  "menu.logout": "Log Out",
  "menu.logoutSuccess": "Logged out successfully",

  // ===== Site Messages =====
  "notice.title": "Messages",
  "notice.empty": "No messages yet",
  "notice.loading": "Loading...",
  "notice.loadMore": "Load more",
  "notice.noMore": "No more messages",
  "notice.unread": "unread",
  "notice.detail": "Message Details",
  "notice.close": "Close",


  // ===== Footer =====
  "footer.contactEmail": "Contact Email",

  // ===== Home Page =====
  "home.heroTitle1": "Global New Compute Power Lord",
  "home.heroTitle2": "Dual-Driven Wealth Engine",
  "home.heroDesc":
    "The platform prioritizes mature sites pre-locked for leasing by AI giants like Microsoft, OpenAI, and DeepSeek",
  "home.heroBtn": "Get Compute Returns Now →",
  "home.statTrade": "Daily Trading Volume",
  "home.statTradeValue": "1B+",
  "home.statReliability": "Reliability",
  "home.statGlobal": "Serving Globally",
  "home.buildTitle1": "Build Your",
  "home.buildTitle2": "Exclusive Compute Center",
  "home.buildDesc1":
    "Independent Management · Independent Leasing · Transparent Returns — We only handle operations,",
  "home.buildDesc2": "All returns belong to the builder",
  "home.buildFeature1Title": "Independent Management",
  "home.buildFeature1Desc":
    "You have full control of your data center, deciding leasing strategies and pricing",
  "home.buildFeature2Title": "Transparent Returns",
  "home.buildFeature2Desc":
    "Real-time financial data visualization, every return is clearly traceable",
  "home.buildFeature3Title": "Professional Operations",
  "home.buildFeature3Desc":
    "We handle hardware maintenance, network support, 7×24 technical support",
  "home.buildFeature4Title": "All Returns Yours",
  "home.buildFeature4Desc":
    "After deducting basic operational costs, all leasing returns belong to the builder",
  "home.buildBtn": "Build Now →",
  "home.buildStatsTitle": "📈 Build Returns Overview",
  "home.buildStatsUpdate": "Real-time Update",
  "home.buildStatRooms": "Data Centers Built",
  "home.buildStatServers": "Servers Running",
  "home.buildStatProfit": "Total Builder Returns",
  "home.buildStatPayback": "Average Payback Period",
  "home.buildStatMonth": "months",
  "home.buildCta": "🎯 Join now and start your compute infrastructure business",
  "home.buildCtaBtn": "Learn More",
  "home.featuresBadge": "✦ Core Advantages",
  "home.featuresTitle1": "Why Choose",
  "home.featuresTitle2": "AETRIVOL",
  "home.feature1Title": "Efficient & Convenient",
  "home.feature1Desc":
    "AETRIVOL leverages its advantages to give individuals access to the compute era dividends",
  "home.feature2Title": "National-Level Security",
  "home.feature2Desc":
    "Multi-layer network protection, encrypted data transmission, 7×24 security monitoring",
  "home.feature3Title": "High-Performance Hardware",
  "home.feature3Desc":
    "NVIDIA's latest generation GPUs with high-speed NVMe storage and DDR5 memory",
  "home.feature4Title": "Global Nodes",
  "home.feature4Desc":
    "Covering data centers in Asia-Pacific, Europe, and North America with low-latency global acceleration",
  "home.appBadge": "📱 Mobile",
  "home.appTitle": "AETRIVOL APP",
  "home.appDesc2": "Stay on top of compute market trends anytime, anywhere,",
  "home.appDesc3": "Manage your GPU compute with one tap.",
  "home.appQrText": "Scan to Download App",
  "home.appStore": "App Store",
  "home.googlePlay": "Google Play",
  "home.walletsTitle1": "Partner",
  "home.walletsTitle2": "Wallets",
  "home.walletsDesc": "Connect your trusted wallets and manage assets securely",
  "home.settleTitle1": "Real-time",
  "home.settleTitle2": "Settlement Updates",
  "home.settleDesc": "Real-time return settlement display for global users",
  "home.modalTitle": "Coming Soon",
  "home.modalDesc1": "No new data center projects available at the moment",
  "home.modalDesc2": "Thank you for your attention and support!",
  "home.modalBtn": "Got It",

  // ===== Home - Compute Countries =====
  "tokenList.title1": "Choose Your",
  "tokenList.title2": "Compute Country",
  "tokenList.desc":
    "World-leading compute countries, low investment, high returns",
  "tokenList.buy": "Buy Now",
  "tokenList.more": "More Products",
  "tokenList.tagHot": "🔥 Hot",
  "tokenList.tagProfit": "💰 High Return",
  "tokenList.tagRecommend": "⭐ Recommended",
  "tokenList.tagNew": "🆕 New",

  // ===== Home - Server Rental =====
  "serverList.title1": "Server",
  "serverList.title2": "Rental",
  "serverList.desc":
    "Mature high-performance servers to generate excess rental returns",
  "serverList.dailyIncome": "Daily Income",
  "serverList.value": "Server Value",
  "serverList.yield": "Yield",
  "serverList.gpu": "GPU",
  "serverList.vram": "VRAM",
  "serverList.storage": "Storage",
  "serverList.status": "Status",
  "serverList.available": "✅ Available",
  "serverList.full": "⏳ Full",
  "serverList.countdown": "Starts In",
  "serverList.over": "Ends In",
  "serverList.yunxz": "Running",
  "serverList.yunxzjs": "Ends In",
  "serverList.days": "days",
  "serverList.btnFull": "Fully Subscribed",
  "serverList.btnRent": "Rent Now →",
  "serverList.btnWait": "Waiting to Start",
  "serverList.look": "View Details",
  "serverList.btnEnded": "Ended",
  "serverList.more": "View More Products",
  "serverList.spec1": "Entry",
  "serverList.spec2": "Light",
  "serverList.spec3": "Performance",
  "serverList.spec4": "Flagship",
  "serverList.tagHot": "🔥 Hot",
  "serverList.tagRecommend": "⭐ Recommended",
  "serverList.tagNew": "🌟 New",

  // ===== Home - Settlement Carousel =====
  "settle.amount": "Settlement Amount",
  "settle.status": "Settled",
  "settle.power": "Compute Value",
  "settle.rental": "Server Rental",
  "settle.basic": "Basic Returns",
  "settle.cycle": "Cycle Returns",
  "settle.phase1": "Phase 1",
  "settle.phase2": "Phase 2",
  "settle.phase3": "Phase 3",
  "settle.phase4": "Phase 4",

  // ===== Member Center =====
  "member.recharge": "Deposit",
  "member.withdraw": "Withdraw",
  "member.tabProducts": "My Products",
  "member.tabHistory": "History",
  "member.tabWalletLog": "Wallet Records",
  "member.tabDeposits": "Deposit Records",
  "member.tabWithdraws": "Withdrawal Records",
  "member.tabAddresses": "Withdrawal Addresses",
  "member.avatarAlt": "User Avatar",
  "member.settingsTitle": "Settings",
  "member.logoutTitle": "Log Out",
  "member.tabTokenProduct": "Compute Products",
  "member.tabRentProduct": "Rental Products",

  // ===== Settings Page =====
  "setting.back": "Back",
  "setting.title": "⚙️ Settings",
  "setting.menuProfile": "Profile",
  "setting.menuSecurity": "Account Security",
  "setting.menuVerify": "Account Verification",
  "setting.menuChangePwd": "Change Password",
  "setting.menuTradePwd": "Trading Password",
  "setting.getUserInfoFail": "Failed to get user info",

  // ===== Settings - Profile =====
  "profile.title": "Profile",
  "profile.subtitle": "Manage your basic information",
  "profile.avatar": "Avatar",
  "profile.avatarAlt": "Avatar",
  "profile.changeAvatar": "Change Avatar",
  "profile.systemAvatar": "System Avatar",
  "profile.firstName": "First Name",
  "profile.firstNamePlaceholder": "Enter first name",
  "profile.lastName": "Last Name",
  "profile.lastNamePlaceholder": "Enter last name",
  "profile.phone": "Phone",
  "profile.phonePlaceholder": "Enter phone number",
  "profile.address": "Address",
  "profile.addressPlaceholder": "Enter address",
  "profile.authUnverified": "Not Verified",
  "profile.gender": "Gender",
  "profile.birthday": "Birthday",
  "profile.birthdayPlaceholder": "Select birthday",
  "profile.country": "Country",
  "profile.countryPlaceholder": "Select country",
  "profile.saving": "Saving...",
  "profile.saveInfo": "Save Info",
  "profile.selectSystemAvatar": "Select System Avatar",
  "profile.avatarAltNum": "Avatar {count}",
  "profile.selectImageFile": "Please select an image file",
  "profile.imageTooLarge": "Image size cannot exceed 5MB",
  "profile.uploadFail": "Upload failed",
  "profile.updateFail": "Update failed",
  "profile.updateSuccess": "Update successful",
  "profile.uploadFailNoPath": "Upload failed, no image URL obtained",
  "profile.uploadFailRetry": "Upload failed, please try again later",
  "profile.saveFail": "Save failed",
  "profile.saveSuccess": "Save successful",
  "profile.saveFailRetry": "Save failed, please try again later",

  // ===== Settings - Verification =====
  "verifyPanel.title": "Account Verification",
  "verifyPanel.subtitle": "Enhance account permissions and trust level",
  "verifyPanel.realName": "Real Name Verification",
  "verifyPanel.realNameDesc":
    "You have submitted your real name verification information",
  "verifyPanel.verified": "Verified ✓",
  "verifyPanel.goVerify": "Verify Now →",

  // ===== Settings - Account Security =====
  "securityPanel.title": "Account Security",
  "securityPanel.subtitle": "Protect your account security",
  "securityPanel.phoneBind": "Phone Binding",
  "securityPanel.phoneBound": "Bound {phone}",
  "securityPanel.notBound": "Not Bound",
  "securityPanel.emailBind": "Email Binding",
  "securityPanel.emailBound": "Bound {email}",
  "securityPanel.twofa": "Two-Factor Authentication (2FA)",
  "securityPanel.twofaOn": "Enabled · Dynamic code required for each login",
  "securityPanel.twofaOff":
    "Disabled · Recommended to enable for enhanced security",
  "securityPanel.twofaEnabled": "Enabled ✓",
  "securityPanel.enableTwofa": "Enable 2FA",
  "securityPanel.disableTwofaTitle": "Disable 2FA",
  "securityPanel.enableTwofaTitle": "Enable 2FA",
  "securityPanel.qrAlt": "2FA QR Code",
  "securityPanel.tip1":
    "1. Download Google Authenticator or Microsoft Authenticator",
  "securityPanel.tip2": "2. Scan the QR code above or enter the secret key",
  "securityPanel.copy": "Copy",
  "securityPanel.verifyCode": "Verification Code",
  "securityPanel.verifyCodePlaceholder": "Enter 6-digit dynamic code",
  "securityPanel.emailCode": "Email Code",
  "securityPanel.emailCodePlaceholder": "Enter email verification code",
  "securityPanel.resend": "Retry in {count}s",
  "securityPanel.sendCode": "Send Code",
  "securityPanel.disableWarning1":
    "After disabling 2FA, your account will lose additional security protection.",
  "securityPanel.disableWarning2": "Please confirm you want to disable 2FA.",
  "securityPanel.cancel": "Cancel",
  "securityPanel.confirmDisable": "Confirm Disable",
  "securityPanel.confirmEnable": "Confirm Enable",
  "securityPanel.getSecretFail": "Failed to get secret key",
  "securityPanel.copySuccess": "Secret key copied to clipboard",
  "securityPanel.copyFail": "Failed to copy secret key",
  "securityPanel.enterVerifyCode": "Please enter 6-digit dynamic code",
  "securityPanel.operationFail": "Operation failed",
  "securityPanel.twofaEnabledMsg": "2FA has been enabled!",
  "securityPanel.twofaDisabledMsg": "2FA has been disabled!",
  "securityPanel.enterEmailCode": "Please enter email verification code",

  // ===== Settings - Change Password =====
  "changePwd.title": "Change Password",
  "changePwd.subtitle":
    "Change your password regularly to protect your account",
  "changePwd.warning":
    "You have not enabled 2FA and cannot change your password. Please enable 2FA first.",
  "changePwd.goEnable": "Enable Now",
  "changePwd.newPwd": "New Password",
  "changePwd.newPwdPlaceholder": "Enter new password (at least 6 characters)",
  "changePwd.confirmPwd": "Confirm New Password",
  "changePwd.confirmPwdPlaceholder": "Enter new password again",
  "changePwd.emailCode": "Email Code",
  "changePwd.emailCodePlaceholder": "Enter email verification code",
  "changePwd.resend": "Retry in {count}s",
  "changePwd.sendCode": "Send Code",
  "changePwd.confirmBtn": "Confirm Change",
  "changePwd.twofaDesc":
    "Enter your 2FA code to send the email verification code",
  "changePwd.pwdTooShort": "New password must be at least 6 characters",
  "changePwd.pwdMismatch": "The two new passwords do not match",
  "changePwd.enableTwofaFirst":
    "Please enable 2FA before changing your password",
  "changePwd.codeError": "Verification code error",
  "changePwd.enterEmailCode": "Please enter email verification code",
  "changePwd.success": "Password changed successfully! Please log in again",

  // ===== Settings - Trading Password =====
  "tradePwd.title": "Trading Password",
  "tradePwd.subtitle": "Protect your asset security",
  "tradePwd.warning":
    "You have not enabled 2FA and cannot change your trading password. Please enable 2FA first.",
  "tradePwd.goEnable": "Enable Now",
  "tradePwd.newPwd": "New Trading Password",
  "tradePwd.newPwdPlaceholder":
    "Enter new trading password (at least 6 characters)",
  "tradePwd.confirmPwd": "Confirm Trading Password",
  "tradePwd.confirmPwdPlaceholder": "Enter new trading password again",
  "tradePwd.emailCode": "Email Code",
  "tradePwd.emailCodePlaceholder": "Enter email verification code",
  "tradePwd.resend": "Retry in {count}s",
  "tradePwd.sendCode": "Send Code",
  "tradePwd.confirmBtn": "Confirm Change",
  "tradePwd.twofaDesc":
    "Enter your 2FA code to send the email verification code",
  "tradePwd.pwdTooShort": "New trading password must be at least 6 characters",
  "tradePwd.pwdMismatch": "The two trading passwords do not match",
  "tradePwd.enableTwofaFirst":
    "Please enable 2FA before changing your trading password",
  "tradePwd.codeError": "Verification code error",
  "tradePwd.enterEmailCode": "Please enter email verification code",
  "tradePwd.success": "Trading password changed successfully!",

  // ===== Member Center - History =====
  "history.tabToken": "Compute Records",
  "history.tabRent": "Rental Records",

  // ===== Member Center - Compute History =====
  "historyToken.type": "Type",
  "historyToken.allType": "All Types",
  "historyToken.buy": "Purchase",
  "historyToken.income": "Income",
  "historyToken.reset": "Reset",
  "historyToken.loading": "Loading...",
  "historyToken.empty": "No products",
  "historyToken.date": "Date",
  "historyToken.product": "Product",
  "historyToken.quantity": "Quantity",
  "historyToken.amount": "Amount",
  "historyToken.fee": "Fee",
  "historyToken.total": "Total",
  "historyToken.time": "Time",
  "historyToken.profit": "Profit/Loss",
  "historyToken.deduct": "Deduction",
  "historyToken.profitPositive": "Profit",
  "historyToken.profitNegative": "Loss",
  "historyToken.unknownStatus": "Unknown Status",
  "historyToken.paginationInfo":
    "Total {total} items, Page {page} / {totalPages}",
  "historyToken.firstPage": "First",
  "historyToken.prevPage": "Prev",
  "historyToken.nextPage": "Next",
  "historyToken.lastPage": "Last",
  "historyToken.perPage": "{count}/page",

  // ===== Member Center - Rental History =====
  "historyServer.type": "Type",
  "historyServer.allType": "All Types",
  "historyServer.buy": "Purchase",
  "historyServer.income": "Income",
  "historyServer.reset": "Reset",
  "historyServer.loading": "Loading...",
  "historyServer.empty": "No products",
  "historyServer.date": "Date",
  "historyServer.product": "Product",
  "historyServer.share": "Share",
  "historyServer.amount": "Amount",
  "historyServer.fee": "Fee",
  "historyServer.total": "Total",
  "historyServer.time": "Time",
  "historyServer.unknownStatus": "Unknown Status",
  "historyServer.paginationInfo":
    "Total {total} items, Page {page} / {totalPages}",
  "historyServer.firstPage": "First",
  "historyServer.prevPage": "Prev",
  "historyServer.nextPage": "Next",
  "historyServer.lastPage": "Last",
  "historyServer.perPage": "{count}/page",

  // ===== Member Center - Deposit Records =====
  "deposit.loading": "Loading...",
  "deposit.empty": "No deposit records",
  "deposit.coin": "Coin",
  "deposit.quantity": "Quantity",
  "deposit.network": "Network",
  "deposit.address": "Address",
  "deposit.status": "Status",
  "deposit.time": "Time",
  "deposit.success": "Success",
  "deposit.processing": "Processing",
  "deposit.paginationInfo": "Total {total} items, Page {page} / {totalPages}",
  "deposit.firstPage": "First",
  "deposit.prevPage": "Prev",
  "deposit.nextPage": "Next",
  "deposit.lastPage": "Last",
  "deposit.perPage": "{count}/page",

  // ===== Member Center - Withdrawal Records =====
  "withdrawal.loading": "Loading...",
  "withdrawal.empty": "No withdrawal records",
  "withdrawal.coin": "Coin",
  "withdrawal.quantity": "Quantity",
  "withdrawal.network": "Network",
  "withdrawal.address": "Address",
  "withdrawal.status": "Status",
  "withdrawal.time": "Time",
  "withdrawal.statusProcessing": "Processing",
  "withdrawal.statusSuccess": "Success",
  "withdrawal.statusFailed": "Failed",
  "withdrawal.statusUnknown": "Unknown",
  "withdrawal.paginationInfo":
    "Total {total} items, Page {page} / {totalPages}",
  "withdrawal.firstPage": "First",
  "withdrawal.prevPage": "Prev",
  "withdrawal.nextPage": "Next",
  "withdrawal.lastPage": "Last",
  "withdrawal.perPage": "{count}/page",

  // ===== Member Center - Withdrawal Addresses =====
  "addresse.title": "Withdrawal Addresses",
  "addresse.addAddress": "+ Add Address",
  "addresse.loading": "Loading...",
  "addresse.empty": "No withdrawal addresses",
  "addresse.coin": "Coin",
  "addresse.network": "Network",
  "addresse.address": "Address",
  "addresse.time": "Time",
  "addresse.action": "Action",
  "addresse.delete": "Delete",
  "addresse.deleteConfirm":
    "Are you sure you want to delete this withdrawal address? This action cannot be undone.",
  "addresse.cancel": "Cancel",
  "addresse.confirmDelete": "Confirm Delete",
  "addresse.deleteSuccess": "Deleted successfully",
  "addresse.paginationInfo": "Total {total} items, Page {page} / {totalPages}",
  "addresse.firstPage": "First",
  "addresse.prevPage": "Prev",
  "addresse.nextPage": "Next",
  "addresse.lastPage": "Last",
  "addresse.perPage": "{count}/page",

  // ===== Member Center - Wallet Records =====
  "walletLog.type": "Type",
  "walletLog.allType": "All Types",
  "walletLog.reset": "Reset",
  "walletLog.loading": "Loading...",
  "walletLog.empty": "No products",
  "walletLog.project": "Project",
  "walletLog.amount": "Amount",
  "walletLog.time": "Time",
  "walletLog.day": "days",
  "walletLog.paginationInfo": "Total {total} items, Page {page} / {totalPages}",
  "walletLog.firstPage": "First",
  "walletLog.prevPage": "Prev",
  "walletLog.nextPage": "Next",
  "walletLog.lastPage": "Last",
  "walletLog.perPage": "{count}/page",
  "walletLog.typeDeposit": "Deposit",
  "walletLog.typeWithdraw": "Withdrawal",
  "walletLog.typePay": "Payment",
  "walletLog.typeTokenIncome": "Compute Profit",
  "walletLog.typeTokenLoss": "Compute Loss",
  "walletLog.typeServerIncome": "Server Income",
  "walletLog.typeTransferReturn": "Withdrawal Return",
  "walletLog.typeFreezeBuy": "(Purchase) Frozen",
  "walletLog.typeServerRent": "Server Rent",
  "walletLog.typeUnfreeze": "(Expired) Unfrozen",
  "walletLog.typeCompute": "Compute",
  "walletLog.typeRent": "Rental",
  "walletLog.statusUnknown": "Unknown Status",
  "walletLog.titlePower": "Compute",
  "walletLog.titleRent": "Rental",
  "walletLog.statusDeposit": "Deposit",
  "walletLog.statusWithdrawal": "Withdrawal",
  "walletLog.statusPay": "Payment",
  "walletLog.statusPowerProfit": "Compute Profit",
  "walletLog.statusPowerLoss": "Compute Loss",
  "walletLog.statusServerIncome": "Server Income",
  "walletLog.statusWithdrawalReturn": "Withdrawal Return",
  "walletLog.statusPurchaseFreeze": "(Purchase) Frozen",
  "walletLog.statusServerRent": "Server Rent",
  "walletLog.statusExpireUnfreeze": "(Expired) Unfrozen",

  // ===== Member Center - Asset Overview =====
  "memberBox.assetOverview": "Asset Overview",
  "memberBox.realTime": "Real-time Update",
  "memberBox.totalAssets": "Total Assets",
  "memberBox.vsYesterday": "vs Yesterday",
  "memberBox.availableBalance": "Available Balance",
  "memberBox.frozenFunds": "Frozen Funds",
  "memberBox.incomeTrend": "Income Trend",
  "memberBox.hashIncome": "Compute Income",
  "memberBox.leaseIncome": "Rental Income",
  "memberBox.hashIncomeTotal": "Total Compute Income",
  "memberBox.leaseIncomeTotal": "Total Rental Income",
  "memberBox.totalIncome": "Total Income",
  "memberBox.vsLastDay": "vs Last Day",
  "memberBox.time7d": "7D",
  "memberBox.time15d": "15D",
  "memberBox.time30d": "30D",

  // ===== Member Center - Product List =====
  "productToken.region": "Region",
  "productToken.allRegion": "All Regions",
  "productToken.status": "Status",
  "productToken.allStatus": "All Status",
  "productToken.statusActive": "Active",
  "productToken.statusCompleted": "Completed",
  "productToken.statusFrozen": "Frozen",
  "productToken.statusUnknown": "Unknown Status",
  "productToken.reset": "Reset",
  "productToken.loading": "Loading...",
  "productToken.empty": "No products",
  "productToken.quantity": "Quantity",
  "productToken.period": "Period",
  "productToken.latestProfit": "Latest P/L",
  "productToken.settledProfit": "Settled P/L",
  "productToken.periodProfit": "Period P/L",
  "productToken.totalProfit": "Total P/L",
  "productToken.action": "Action",
  "productToken.view": "View",
  "productToken.day": "days",
  "productToken.paginationInfo":
    "Total {total} items, Page {page} / {totalPages}",
  "productToken.firstPage": "First",
  "productToken.prevPage": "Prev",
  "productToken.nextPage": "Next",
  "productToken.lastPage": "Last",
  "productToken.perPage": "{count}/page",
  "productToken.detailTitle": "Product Details",
  "productToken.productCode": "Product Code",
  "productToken.orderCode": "Order Code",
  "productToken.orderName": "Product Name",
  "productToken.tradeInfo": "Trade Info",
  "productToken.tradeTime": "Trade Time",
  "productToken.buyPrice": "Purchase Price",
  "productToken.principal": "Principal",
  "productToken.fee": "Fee",
  "productToken.latestPrice": "Latest Price",
  "productToken.profitInfo": "P/L Info",
  "productToken.estimatedProfit": "Estimated Total P/L",
  "productToken.remark": "Remark",
  "productToken.close": "Close",

  // ===== Member Center - Server Product List =====
  "productServer.region": "Region",
  "productServer.allRegion": "All Regions",
  "productServer.status": "Status",
  "productServer.allStatus": "All Status",
  "productServer.statusActive": "Active",
  "productServer.statusActive2": "Running",
  "productServer.statusCompleted": "Completed",
  "productServer.statusFrozen": "Frozen",
  "productServer.statusUnknown": "Unknown Status",
  "productServer.reset": "Reset",
  "productServer.loading": "Loading...",
  "productServer.empty": "No products",
  "productServer.productName": "Product Name",
  "productServer.share": "Share",
  "productServer.countdown": "Countdown",
  "productServer.unsettledIncome": "Unsettled Income",
  "productServer.settled": "Settled",
  "productServer.totalIncome": "Total Income",
  "productServer.action": "Action",
  "productServer.view": "View",
  "productServer.day": "days",
  "productServer.paginationInfo":
    "Total {total} items, Page {page} / {totalPages}",
  "productServer.firstPage": "First",
  "productServer.prevPage": "Prev",
  "productServer.nextPage": "Next",
  "productServer.lastPage": "Last",
  "productServer.perPage": "{count}/page",
  "productServer.detailTitle": "Product Details",
  "productServer.productCode": "Product Code",
  "productServer.orderCode": "Order Code",
  "productServer.orderName": "Product Name",
  "productServer.leaseInfo": "Lease Info",
  "productServer.leaseDate": "Lease Date",
  "productServer.rent": "Rent",
  "productServer.maintenanceFee": "Maintenance Fee",
  "productServer.profitInfo": "Income Info",
  "productServer.estimatedLeaseIncome": "Estimated Total Lease Income",
  "productServer.settledIncome": "Settled Income",
  "productServer.phase": "{count} Phase",
  "productServer.phaseList": "Phase Earnings",
  "productServer.currentPhase": "Current Phase",
  "productServer.remark": "Remark",
  "productServer.close": "Close",

  // ===== Registration / Qualification Application =====
  "register.back": "Back to Login",
  "register.statusBadge": "Qualification Application · Manual Review",
  "register.title": "Apply for Qualification",
  "register.subtitle":
    "After submitting your information, we will complete the review within 24 hours and notify you by email",
  "register.basicInfo": "Basic Information",
  "register.firstNamePlaceholder": "Enter your first name",
  "register.lastNamePlaceholder": "Enter your last name",
  "register.genderMale": "Male",
  "register.genderFemale": "Female",
  "register.genderSecret": "Prefer Not to Say",
  "register.birthdayPlaceholder": "Select date of birth",
  "register.maritalStatus": "Marital Status",
  "register.maritalUnmarried": "Single",
  "register.maritalMarried": "Married",
  "register.maritalDivorced": "Divorced",
  "register.maritalWidowed": "Widowed",
  "register.contactAddress": "Contact Address",
  "register.addressPlaceholder": "Enter contact address",
  "register.occupationInfo": "Occupation Information",
  "register.workUnitPlaceholder": "Enter work unit",
  "register.workAddressPlaceholder": "Enter work address",
  "register.occupationPlaceholder": "Enter your occupation",
  "register.incomePlaceholder": "Select annual income range",
  "register.incomeBelow5": "Below 50K",
  "register.income5to10": "50K - 100K",
  "register.income10to20": "100K - 200K",
  "register.income20to50": "200K - 500K",
  "register.income50to100": "500K - 1M",
  "register.incomeAbove100": "Above 1M",
  "register.otherInfo": "Other Information",
  "register.remarksPlaceholder":
    "Additional notes (optional, e.g., application reason, special needs)",
  "register.accountInfo": "Account Information",
  "register.inviteCodePlaceholder": "Enter verification code",
  "register.emailPlaceholder":
    "Enter email address (review result will be sent to this email)",
  "register.verifyCodePlaceholder": "Enter email verification code",
  "register.agreementText":
    "I confirm that the above information is true and valid, and agree to the",
  "register.agreementLink": "User Agreement",
  "register.auditNotice1": "After submission, we will conduct a manual review",
  "register.auditNotice2": "within 24 hours",
  "register.auditNotice3":
    " and notify you by email. Please ensure your email address is correct.",
  "register.submitBtn": "Submit Application",
  "register.submitting": "Submitting...",
  "register.hasAccount": "Already have an account?",
  "register.gotoLogin": "Log In",
  "register.successTitle": "Submitted Successfully!",
  "register.successDesc1":
    "Your qualification application has been received. We will complete the review within",
  "register.successDesc2": "24 hours",
  "register.successDesc3": ".",
  "register.successDesc4": "The review result will be sent to:",
  "register.successTip": "Please check your email. Thank you for applying!",
  "register.modalBtn": "Got It",
  "register.sending": "Sending",
  "register.resendSuffix": "to retry",
  "register.auditNoticeMid": ", the review result will be sent within",
  "register.invalidEmail": "Please enter a valid email address",
  "register.codeSent": "Verification code sent to your email, please check",
  "register.inviteCodeInvalid": "Please enter a 6-digit invite code",
  "register.verifyCodeInvalid":
    "Please enter a 4-digit email verification code",
  "register.firstNameRequired": "Please enter your real first name",
  "register.lastNameRequired": "Please enter your real last name",
  "register.genderRequired": "Please select your gender",
  "register.birthdayRequired": "Please select your date of birth",
  "register.maritalRequired": "Please select your marital status",
  "register.addressRequired": "Please enter your address",
  "register.workUnitRequired": "Please enter your work unit",
  "register.workAddressRequired": "Please enter your work address",
  "register.occupationRequired": "Please enter your occupation",
  "register.incomeRequired": "Please select your annual income range",
  "register.agreeRequired":
    "Please read and agree to the qualification review terms and privacy policy",
  "register.registerFail": "Registration failed",
  "register.submitFail": "Submission failed, please try again later",

  // ===== Login Page =====
  "login.title": "AI Compute Cloud",
  "login.subtitle": "AI computing power cloud",
  "login.usernamePlaceholder": "Enter account name",
  "login.passwordPlaceholder": "Enter account password",
  "login.forgotPassword": "Forgot Password",
  "login.loginBtn": "Log In",
  "login.noQualification": "No qualification yet?",
  "login.applyNow": "Apply Now",
  "login.loginSuccess": "Login successful",
  "login.enterCredentials": "Please enter account and password",
  "login.loading": "Loading...",

  // ===== Reset Password Page =====
  "reset.back": "Back to Login",
  "reset.title": "Reset Password",
  "reset.subtitleStep1": "Verify identity and reset your account password",
  "reset.subtitleStep2": "Set a new password to ensure account security",
  "reset.emailPlaceholder": "Enter registered email address",
  "reset.captchaPlaceholder": "Enter verification code",
  "reset.sending": "Sending",
  "reset.getCaptcha": "Get Code",
  "reset.nextStep": "Next Step",
  "reset.newPasswordPlaceholder": "Set new password (at least 6 characters)",
  "reset.confirmPasswordPlaceholder": "Enter new password again",
  "reset.resetBtn": "Reset Now",
  "reset.rememberPassword": "Remember password?",
  "reset.gotoLogin": "Log In",
  "reset.invalidEmail": "Please enter a valid email address",
  "reset.captchaSent": "Verification code sent successfully",
  "reset.captchaInvalid":
    "Please enter a valid verification code (at least 4 characters)",
  "reset.passwordTooShort": "New password must be at least 6 characters",
  "reset.passwordMismatch": "The two passwords do not match",
  "reset.resetSuccess": "Password reset successfully! Please log in again",

  // ===== Identity Verification Page =====
  "verify.statusBadge": "Identity Verification · Information Form",
  "verify.title": "Account Verification",
  "verify.subtitle":
    "Please fill in your real identity information. A manual review will be conducted after submission",
  "verify.accountSecurity": "Account Security",
  "verify.loginPassword": "Login Password",
  "verify.confirmLoginPassword": "Confirm Login Password",
  "verify.tradePassword": "Trading Password",
  "verify.confirmTradePassword": "Confirm Trading Password",
  "verify.securityQuestion": "Security Question",
  "verify.securityAnswer": "Security Answer",
  "verify.basicInfo": "Basic Information",
  "verify.country": "Country",
  "verify.countryPlaceholder": "Select your country",
  "verify.phone": "Phone Number",
  "verify.realName": "Real Name",
  "verify.idNumber": "ID Number",
  "verify.idPhoto": "ID Photo",
  "verify.frontPhoto": "Front",
  "verify.backPhoto": "Back",
  "verify.handPhoto": "Handheld ID Photo",
  "verify.uploading": "Uploading...",
  "verify.clickUpload": "Click to Upload",
  "verify.uploadHint": "Supports JPG / PNG, recommended within 5MB",
  "verify.uploadHandHint":
    "Please hold your ID while taking the photo, ensuring your face and ID information are clearly visible",
  "verify.reupload": "Re-upload",
  "verify.auditNotice1": "A manual review will be conducted after submission",
  "verify.auditNoticeMid": ", the review result will be sent within",
  "verify.auditNotice2": "24 hours",
  "verify.auditNotice3": ". Please ensure your information is accurate.",
  "verify.submitBtn": "Submit Verification",
  "verify.submitting": "Submitting...",
  "verify.hasAccount": "Already have an account?",
  "verify.gotoLogin": "Log In",
  "verify.successTitle": "Submitted Successfully!",
  "verify.successDesc1":
    "Your verification information has been submitted. We will complete the review within",
  "verify.successDesc2": "24 hours",
  "verify.successDesc3": ".",
  "verify.successDesc4": "The review result will be sent to you via SMS.",
  "verify.successTip":
    "Please keep your phone available. Thank you for your cooperation!",
  "verify.modalBtn": "Got It",
  "verify.loginPasswordPlaceholder":
    "Set login password (at least 6 characters)",
  "verify.confirmLoginPasswordPlaceholder": "Enter login password again",
  "verify.tradePasswordPlaceholder":
    "Set trading password (at least 6 characters)",
  "verify.confirmTradePasswordPlaceholder": "Enter trading password again",
  "verify.securityQuestionPlaceholder": "Enter security question",
  "verify.securityAnswerPlaceholder": "Enter security answer",
  "verify.phonePlaceholder": "Enter phone number",
  "verify.realNamePlaceholder": "Enter real name (must match ID)",
  "verify.idNumberPlaceholder": "Enter ID number",
  "verify.uploadImage": "Please upload an image file",
  "verify.imageTooLarge": "Image size cannot exceed 5MB",
  "verify.uploadSuccess": "Image uploaded successfully",
  "verify.uploadFail": "Image upload failed",
  "verify.uploadFailRetry": "Image upload failed, please try again later",
  "verify.passwordTooShort": "Password must be at least 6 characters",
  "verify.confirmPasswordRequired": "Please enter the password again",
  "verify.passwordMismatch": "The two passwords do not match",
  "verify.tradePasswordTooShort":
    "Trading password must be at least 6 characters",
  "verify.confirmTradePasswordRequired":
    "Please enter the trading password again",
  "verify.tradePasswordMismatch": "The two trading passwords do not match",
  "verify.securityQuestionRequired": "Please enter a security question",
  "verify.countryRequired": "Please select your country",
  "verify.phoneInvalid": "Please enter a valid phone number",
  "verify.realNameRequired":
    "Please enter your real name (at least 2 characters)",
  "verify.idNumberInvalid": "Please enter a valid ID number",
  "verify.idFrontRequired": "Please upload the front of your ID",
  "verify.idBackRequired": "Please upload the back of your ID",
  "verify.idHandRequired": "Please upload a handheld ID photo",
  "verify.submitSuccess": "Submitted successfully",
  "verify.submitFail": "Submission failed",
  "verify.submitFailRetry": "Submission failed, please try again later",

  // ===== Rental List Page =====
  "rental.title1": "Server",
  "rental.title2": "Rental",
  "rental.desc":
    "Curated high-performance servers to invest in your personal compute assets and support global compute development",
  "rental.statServers": "Rentable Servers",
  "rental.statAvailability": "Availability",
  "rental.statSupport": "Customer Support",
  "rental.searchPlaceholder": "Search server name, GPU model...",
  "rental.filterAll": "All",
  "rental.filterHot": "🔥 Hot",
  "rental.filterRecommend": "⭐ Recommended",
  "rental.filterNew": "🌟 New",
  "rental.sortDefault": "Default Sort",
  "rental.sortRemainingAsc": "Remaining ↑",
  "rental.sortRemainingDesc": "Remaining ↓",
  "rental.sortValueAsc": "Total Value ↑",
  "rental.sortValueDesc": "Total Value ↓",
  "rental.sortIncomeAsc": "Daily Income ↑",
  "rental.sortIncomeDesc": "Daily Income ↓",
  "rental.sortStartAsc": "Start Date ↑",
  "rental.sortStartDesc": "Start Date ↓",
  "rental.sortEndAsc": "End Date ↑",
  "rental.sortEndDesc": "End Date ↓",
  "rental.resultCount": "{count} servers total",
  "rental.loading": "Loading...",
  "rental.empty": "No matching servers found",
  "rental.totalValue": "Total Value",
  "rental.country": "Country",
  "rental.incomeTrend": "Income Trend",
  "rental.activityPeriod": "📅 Period",
  "rental.remaining": "⏳ Remaining",
  "rental.days": "days",
  "rental.memory": "Memory",
  "rental.storage": "Storage",
  "rental.bandwidth": "Bandwidth",
  "rental.status": "Status",
  "rental.available": "✅ Available",
  "rental.full": "⏳ Full",
  "rental.countdown": "Starts In",
  "rental.btnFull": "Fully Subscribed",
  "rental.btnRent": "Rent Now",
  "rental.btnWait": "Waiting to Start",
  "rental.btnEnded": "Ended",
  "rental.btnRentList": "Rent",
  "rental.btnNotStart": "Not Started",
  "rental.NotRent": "Not Available for Rental",
  "rental.value": "Value",
  "rental.prev": "← Prev",
  "rental.next": "Next →",
  "rental.perPage": "{count} / page",
  "rental.processBadge": "📋 Rental Process",
  "rental.processTitle1": "Rent a Server",
  "rental.processTitle2": "in 3 Easy Steps",
  "rental.step1Icon": "🔍",
  "rental.step1Title": "Choose a Server",
  "rental.step1Desc":
    "Browse the server list and choose the right configuration for your needs",
  "rental.step2Icon": "📝",
  "rental.step2Title": "Submit Rental Application",
  "rental.step2Desc":
    "Fill in rental duration, purpose, and other information, then submit for review",
  "rental.step3Icon": "🚀",
  "rental.step3Title": "Deploy & Use",
  "rental.step3Desc":
    "Deploy immediately after approval and start your AI compute journey",
  "rental.ctaTitle": "Haven't found the right server?",
  "rental.ctaDesc":
    "Contact us for a customized solution. Our professional team will recommend the optimal configuration",
  "rental.ctaContact": "Contact Support",
  "rental.ctaFaq": "View FAQ",
  "rental.spec1": "Entry",
  "rental.spec2": "Light",
  "rental.spec3": "Performance",
  "rental.spec4": "Flagship",
  "rental.tagHot": "🔥 Hot",
  "rental.tagRecommend": "⭐ Recommended",
  "rental.tagNew": "🌟 New",
  "rental.statusActive": "Active",
  "rental.statusPending": "Not Started",
  "rental.statusEnded": "Ended",
  "rental.income": "Income",
  "rental.progress": "Progress",
  "rental.countryAlt": "Country",
  "rental.monday": "Mon",
  "rental.tuesday": "Tue",
  "rental.wednesday": "Wed",
  "rental.thursday": "Thu",
  "rental.friday": "Fri",
  "rental.saturday": "Sat",
  "rental.sunday": "Sun",

  // ===== Withdrawal Page =====
  "withdraw.title": "💸 Account Withdrawal",
  "withdraw.desc": "Fast withdrawal, secure arrival",
  "withdraw.balance": "Available Balance",
  "withdraw.methodCrypto": "🪙 Cryptocurrency",
  "withdraw.methodBank": "🏦 Bank Withdrawal",
  "withdraw.selectCoin": "Select Coin",
  "withdraw.selectNetwork": "Select Network",
  "withdraw.address": "Withdrawal Address",
  "withdraw.bindAddress": "➕ Bind Address",
  "withdraw.selectAddress": "Select withdrawal address",
  "withdraw.noAddress": "No available addresses",
  "withdraw.noAddressTip": "⚠️ No bound {coin} address. Please",
  "withdraw.bindLink": "bind an address",
  "withdraw.amount": "Withdrawal Amount",
  "withdraw.emailCode": "Email Code",
  "withdraw.emailCodePlaceholder": "Enter email verification code",
  "withdraw.resend": "Retry in {count}s",
  "withdraw.sendCode": "Send Code",
  "withdraw.expectedArrival": "Expected Arrival",
  "withdraw.networkFee": "Network Fee",
  "withdraw.actualArrival": "Actual Arrival",
  "withdraw.submitting": "⏳ Submitting...",
  "withdraw.confirm": "🚀 Confirm Withdrawal",
  "withdraw.selectFirst": "👆 Please select coin and network",
  "withdraw.minAmount": "Minimum Withdrawal",
  "withdraw.maxAmount": "Maximum Withdrawal",
  "withdraw.all": "All",
  "withdraw.available": "Available",
  "withdraw.insufficientBalance": "Insufficient balance",
  "withdraw.enterAmount": "Please enter withdrawal amount",
  "withdraw.enterCode": "Please enter email verification code",
  "withdraw.selectAddressFirst": "Please select a withdrawal address",
  "withdraw.success": "Withdrawal request submitted",
  "withdraw.fail": "Withdrawal failed",
  "withdraw.arrivalTime": "10-30 minutes",
  "withdraw.noticeTitle": "📋 Withdrawal Notes",
  "withdraw.notice1Title": "Arrival Time",
  "withdraw.notice1Desc":
    "Cryptocurrency withdrawals typically arrive in 10-30 minutes, depending on blockchain network confirmation speed.",
  "withdraw.notice2Title": "Minimum Withdrawal",
  "withdraw.notice2Desc":
    "The minimum withdrawal amount is 0.001 BTC or equivalent in other coins. Amounts below this cannot be submitted.",
  "withdraw.notice3Title": "Address Verification",
  "withdraw.notice3Desc":
    "Please carefully verify the withdrawal address. Incorrect operations may result in permanent asset loss. The platform is not responsible.",
  "withdraw.notice4Title": "Fee Explanation",
  "withdraw.notice4Desc":
    "Withdrawal fees are determined by the blockchain network. The platform does not charge additional fees. Fees will be deducted from the withdrawal amount.",
  "withdraw.codeError": "Verification code error",
  "withdraw.twoFactorDesc":
    "Enter your 2FA code to send the email verification code",
  "withdraw.selectBank": "Select Bank Account",
  "withdraw.selectBankPlaceholder": "Select bank account",
  "withdraw.bankBOC": "Bank of China",
  "withdraw.bankICBC": "ICBC",
  "withdraw.addBank": "+ Add New Account",
  "withdraw.bankAmount": "Withdrawal Amount (USD)",
  "withdraw.exchangeRate": "💱 Exchange Rate",
  "withdraw.arrivalTimeLabel": "⏱️ Arrival Time",
  "withdraw.bankArrivalTime": "1-3 business days",
  "withdraw.bankConfirm": "🏦 Confirm Withdrawal",
  "withdraw.bankSuccess":
    "🏦 Bank withdrawal request submitted. Arrival within 1-3 business days",

  // ===== Deposit Page =====
  "depositPage.title": "💰 Account Deposit",
  "depositPage.desc": "Choose a deposit method for fast arrival",
  "depositPage.balance": "Current Balance",
  "depositPage.methodCrypto": "🪙 Cryptocurrency",
  "depositPage.methodOnline": "💳 Online Deposit",
  "depositPage.coin": "Coin",
  "depositPage.protocol": "Protocol",
  "depositPage.qrAlt": "Deposit QR Code",
  "depositPage.qrPlaceholder": "No QR code available",
  "depositPage.copy": "📋 Copy",
  "depositPage.copied": "✅",
  "depositPage.addressWarning":
    "⚠️ Only supports <strong>{coin}</strong> ({protocol}) transfers. Do not send other assets",
  "depositPage.amountPlaceholder": "Enter deposit amount (optional)",
  "depositPage.transferBtn": "🚀 I've Transferred",
  "depositPage.emptyState": "👆 Please select coin and protocol",
  "depositPage.noticeTitle": "📋 Deposit Notes",
  "depositPage.onlineCardName1": "Credit/Debit Card",
  "depositPage.onlineCardDesc1": "Visa · Mastercard",
  "depositPage.onlineCardBtn1": "Pay →",
  "depositPage.onlineCardName2": "Bank Transfer",
  "depositPage.onlineCardDesc2": "Arrival in 1-3 business days",
  "depositPage.onlineCardBtn2": "Get Info →",
  "depositPage.onlineCardName3": "Third-Party Payment",
  "depositPage.onlineCardDesc3": "Alipay · WeChat · Paypal",
  "depositPage.onlineCardBtn3": "Pay →",
  "depositPage.notice1Title": "Arrival Time",
  "depositPage.notice1Desc":
    "Cryptocurrency deposits require blockchain network confirmation, typically 10-30 minutes depending on network congestion.",
  "depositPage.notice2Title": "Minimum Deposit",
  "depositPage.notice2Desc":
    "The minimum deposit amount is 0.001 BTC or equivalent in other coins. Amounts below this cannot be credited.",
  "depositPage.notice3Title": "Confirmation Requirements",
  "depositPage.notice3Desc":
    "BTC requires 3 network confirmations. ETH/TRX/USDT requires 12 confirmations before being credited to your account balance.",
  "depositPage.notice4Title": "Asset Security Reminder",
  "depositPage.notice4Desc":
    "Please carefully verify the deposit address and protocol type. Incorrect operations may result in permanent asset loss. The platform is not responsible.",
  "depositPage.feeInfo": "💸 Fee: {fee}",

  // ===== Bind Wallet Address Page =====
  "bindAddress.title": "🔗 Bind Wallet Address",
  "bindAddress.desc": "Bind your cryptocurrency wallet address for withdrawals",
  "bindAddress.cardTitle": "➕ Bind New Wallet",
  "bindAddress.selectCoin": "Select Coin",
  "bindAddress.selectProtocol": "Select Protocol",
  "bindAddress.walletAddress": "Wallet Address",
  "bindAddress.walletAddressPlaceholder": "Enter your wallet address",
  "bindAddress.emailCode": "Email Code",
  "bindAddress.emailCodePlaceholder": "Enter email verification code",
  "bindAddress.resend": "Retry in {count}s",
  "bindAddress.sendCode": "Send Code",
  "bindAddress.confirmBind": "🔗 Confirm Binding",
  "bindAddress.noticeTitle": "📋 Binding Notes",
  "bindAddress.twoFactorDesc":
    "Enter your 2FA code to send the email verification code",
  "bindAddress.notice1Title": "Asset Security",
  "bindAddress.notice1Desc":
    "Please ensure the wallet address you bind belongs to you and that you keep the private key secure.",
  "bindAddress.notice2Title": "Withdrawal Restriction",
  "bindAddress.notice2Desc":
    "Withdrawals are not allowed within 24 hours after binding to protect account asset security.",
  "bindAddress.notice3Title": "Email Verification",
  "bindAddress.notice3Desc":
    "Each new wallet binding requires email verification code confirmation.",
  "bindAddress.notice4Title": "Address Verification",
  "bindAddress.notice4Desc":
    "Please carefully verify the wallet address. Incorrect binding may result in assets being unrecoverable.",
  "bindAddress.msgAddressInvalid":
    "⚠️ Please enter a valid wallet address first",
  "bindAddress.msgCodeError": "Verification code error",
  "bindAddress.msgFormInvalid":
    "Please fill in all information and get the email verification code",

  // ===== Error Page =====
  "error.backHome": "Back to Home",
  "error.refresh": "Refresh",
  "error.footerTip":
    "If the problem persists, please contact technical support",
  "error.title404": "Page Not Found",
  "error.desc404":
    "The page you are looking for does not exist or has been removed",

  phase: "Phase",

  // en-gb / en-sg / en-us 英语
  country: {
    1: "United States",
    2: "China",
    3: "Japan",
    4: "South Korea",
    5: "Germany",
    6: "United Kingdom",
    7: "France",
    8: "United Arab Emirates",
    9: "Singapore",
    10: "Israel",
    11: "Russia",
    12: "India",
    13: "Brazil",
    14: "Italy",
    15: "Spain",
    16: "Portugal",
    17: "Netherlands",
    18: "Belgium",
    19: "Switzerland",
    20: "Sweden",
    21: "Norway",
    22: "Finland",
    23: "Denmark",
    24: "Iceland",
    25: "Ireland",
    26: "Austria",
    27: "Poland",
    28: "Czech Republic",
    29: "Hungary",
    30: "Greece",
    31: "Ukraine",
    32: "Belarus",
    33: "Romania",
    34: "Bulgaria",
    35: "Serbia",
    36: "Croatia",
    37: "Albania",
    38: "Estonia",
    39: "Latvia",
    40: "Lithuania",
    41: "Moldova",
    42: "Slovakia",
    43: "Slovenia",
    44: "Bosnia and Herzegovina",
    45: "Montenegro",
    46: "North Macedonia",
    47: "Luxembourg",
    48: "Malta",
    49: "Andorra",
    50: "Monaco",
    51: "Liechtenstein",
    52: "San Marino",
    53: "Vatican City",
    54: "Canada",
    55: "Mexico",
    56: "Cuba",
    57: "Guatemala",
    58: "Honduras",
    59: "Nicaragua",
    60: "Costa Rica",
    61: "Panama",
    62: "Jamaica",
    63: "Haiti",
    64: "Dominican Republic",
    65: "Trinidad and Tobago",
    66: "Dominica",
    67: "Saint Lucia",
    68: "Saint Vincent and the Grenadines",
    69: "Grenada",
    70: "Saint Kitts and Nevis",
    71: "Antigua and Barbuda",
    72: "Bahamas",
    73: "Barbados",
    74: "Belize",
    75: "El Salvador",
    76: "Argentina",
    77: "Colombia",
    78: "Venezuela",
    79: "Peru",
    80: "Chile",
    81: "Ecuador",
    82: "Bolivia",
    83: "Paraguay",
    84: "Uruguay",
    85: "Guyana",
    86: "Suriname",
    87: "Australia",
    88: "New Zealand",
    89: "Papua New Guinea",
    90: "Fiji",
    91: "Solomon Islands",
    92: "Vanuatu",
    93: "Samoa",
    94: "Kiribati",
    95: "Micronesia",
    96: "Marshall Islands",
    97: "Palau",
    98: "Nauru",
    99: "Tuvalu",
    100: "Tonga",
    101: "Cook Islands",
    102: "Niue",
    103: "Egypt",
    104: "South Africa",
    105: "Nigeria",
    106: "Ethiopia",
    107: "Kenya",
    108: "Tanzania",
    109: "Algeria",
    110: "Morocco",
    111: "Sudan",
    112: "South Sudan",
    113: "Ghana",
    114: "Angola",
    115: "Mozambique",
    116: "Madagascar",
    117: "Cameroon",
    118: "Ivory Coast",
    119: "Niger",
    120: "Burkina Faso",
    121: "Mali",
    122: "Senegal",
    123: "Uganda",
    124: "Zambia",
    125: "Zimbabwe",
    126: "Chad",
    127: "Congo",
    128: "Democratic Republic of the Congo",
    129: "Gabon",
    130: "Botswana",
    131: "Namibia",
    132: "Mauritius",
    133: "Rwanda",
    134: "Somalia",
    135: "Djibouti",
    136: "Eritrea",
    137: "Libya",
    138: "Tunisia",
    139: "Sierra Leone",
    140: "Liberia",
    141: "Togo",
    142: "Benin",
    143: "Guinea",
    144: "Guinea-Bissau",
    145: "Gambia",
    146: "Cape Verde",
    147: "São Tomé and Príncipe",
    148: "Equatorial Guinea",
    149: "Mauritania",
    150: "Eswatini",
    151: "Lesotho",
    152: "Malawi",
    153: "Central African Republic",
    154: "Burundi",
    155: "Comoros",
    156: "Seychelles",
    157: "Turkey",
    158: "Iran",
    159: "Iraq",
    160: "Saudi Arabia",
    161: "Mongolia",
    162: "North Korea",
    163: "Indonesia",
    164: "Philippines",
    165: "Vietnam",
    166: "Thailand",
    167: "Malaysia",
    168: "Myanmar",
    169: "Cambodia",
    170: "Laos",
    171: "Brunei",
    172: "Timor-Leste",
    173: "Pakistan",
    174: "Bangladesh",
    175: "Nepal",
    176: "Bhutan",
    177: "Sri Lanka",
    178: "Maldives",
    179: "Kazakhstan",
    180: "Uzbekistan",
    181: "Turkmenistan",
    182: "Kyrgyzstan",
    183: "Tajikistan",
    184: "Afghanistan",
    185: "Syria",
    186: "Jordan",
    187: "Lebanon",
    188: "Palestine",
    189: "Oman",
    190: "Yemen",
    191: "Kuwait",
    192: "Qatar",
    193: "Bahrain",
    194: "Georgia",
    195: "Armenia",
    196: "Azerbaijan",
    197: "Cyprus",
  },

  token: {
    us: {
      content: {
        title: "",
        content: usContent.content,
      },
      t1: {
        title: "Current Status",
        content: usContent.t1,
      },
      t2: {
        title: "Core Advantages",
        content: usContent.t2,
      },
      t3: {
        title: "Challenges",
        content: usContent.t3,
      },
      t4: {
        title: "Future Trends",
        content: usContent.t4,
      },
    },
    cn: {
      content: {
        title: "",
        content: cnContent.content,
      },
      t1: {
        title: "Current Status",
        content: cnContent.t1,
      },
      t2: {
        title: "Core Advantages",
        content: cnContent.t2,
      },
      t3: {
        title: "Challenges",
        content: cnContent.t3,
      },
      t4: {
        title: "Future Trends",
        content: cnContent.t4,
      },
    },
    jp: {
      content: {
        title: "",
        content: jpContent.content,
      },
      t1: {
        title: "Current Status",
        content: jpContent.t1,
      },
      t2: {
        title: "Core Advantages",
        content: jpContent.t2,
      },
      t3: {
        title: "Challenges",
        content: jpContent.t3,
      },
      t4: {
        title: "Future Trends",
        content: jpContent.t4,
      },
    },
    ko: {
      content: {
        title: "",
        content: koContent.content,
      },
      t1: {
        title: "Current Status",
        content: koContent.t1,
      },
      t2: {
        title: "Core Advantages",
        content: koContent.t2,
      },
      t3: {
        title: "Challenges",
        content: koContent.t3,
      },
      t4: {
        title: "Future Trends",
        content: koContent.t4,
      },
    },
    ge: {
      content: {
        title: "",
        content: geContent.content,
      },
      t1: {
        title: "Current Status",
        content: geContent.t1,
      },
      t2: {
        title: "Core Advantages",
        content: geContent.t2,
      },
      t3: {
        title: "Challenges",
        content: geContent.t3,
      },
      t4: {
        title: "Future Trends",
        content: geContent.t4,
      },
    },
    uk: {
      content: {
        title: "",
        content: ukContent.content,
      },
      t1: {
        title: "Current Status",
        content: ukContent.t1,
      },
      t2: {
        title: "Core Advantages",
        content: ukContent.t2,
      },
      t3: {
        title: "Challenges",
        content: ukContent.t3,
      },
      t4: {
        title: "Future Trends",
        content: ukContent.t4,
      },
    },
    fr: {
      content: {
        title: "",
        content: frContent.content,
      },
      t1: {
        title: "Current Status",
        content: frContent.t1,
      },
      t2: {
        title: "Core Advantages",
        content: frContent.t2,
      },
      t3: {
        title: "Challenges",
        content: frContent.t3,
      },
      t4: {
        title: "Future Trends",
        content: frContent.t4,
      },
    },
    uae: {
      content: {
        title: "",
        content: uaeContent.content,
      },
      t1: {
        title: "Current Status",
        content: uaeContent.t1,
      },
      t2: {
        title: "Core Advantages",
        content: uaeContent.t2,
      },
      t3: {
        title: "Challenges",
        content: uaeContent.t3,
      },
      t4: {
        title: "Future Trends",
        content: uaeContent.t4,
      },
    },
    sg: {
      content: {
        title: "",
        content: sgContent.content,
      },
      t1: {
        title: "Current Status",
        content: sgContent.t1,
      },
      t2: {
        title: "Core Advantages",
        content: sgContent.t2,
      },
      t3: {
        title: "Challenges",
        content: sgContent.t3,
      },
      t4: {
        title: "Future Trends",
        content: sgContent.t4,
      },
    },
  },

  // ===== Home - Additional (alt attributes etc.) =====
  "home.altQr": "Scan to download",
  "home.altApp": "App screenshot",
  "home.altWallet": "Wallet icon",

  // ===== Rental Detail Page =====
  "detail.breadcrumbHome": "Home",
  "detail.breadcrumbRental": "Server Rental",
  "detail.breadcrumbDetail": "Details",
  "detail.badgeHot": "🔥 Hot Recommendation",
  "detail.badgeAvailable": "✅ Available",
  "detail.badgeSold": "⏳ Fully Rented",
  "detail.badgeEnded": "⏳ Ended",
  "detail.badgePending": "⏳ Not Started",
  "detail.code": "Code: ",
  "detail.specTitle": "Full Specifications",
  "detail.specGpu": "GPU Model",
  "detail.specVram": "VRAM",
  "detail.specStorage": "Storage",
  "detail.specRam": "Memory",
  "detail.specBandwidth": "Bandwidth",
  "detail.specValue": "Server Value",
  "detail.specCountry": "Country",
  "detail.specCountryFlag": "Country Flag",
  "detail.specStatus": "Status",
  "detail.statusFull": "⏳ Full",
  "detail.statusEnded": "⏳ Ended",
  "detail.statusPending": "⏳ Not Started",
  "detail.statusAvailable": "✅ Available",
  "detail.chartTitle": "Income Trend",
  "detail.chartRealTime": "Real-time",
  "detail.chartHint": "Click to view larger",
  "detail.chart7d": "7D",
  "detail.chart15d": "15D",
  "detail.chart30d": "30D",
  "detail.statMax": "Max",
  "detail.statAvg": "Average",
  "detail.statMin": "Min",
  "detail.statChange": "Change",
  "detail.descTitle": "Product Description",
  "detail.regionTitle": "Region Info",
  "detail.panelTitle": "💎 Rent Now",
  "detail.statusDotFull": "● Full",
  "detail.statusDotEnded": "● Ended",
  "detail.statusDotPending": "● Not Started",
  "detail.statusDotAvailable": "● Available",
  "detail.activityPeriod": "📅 Cycle Time",
  "detail.daysLeft": "left",
  "detail.days": "days",
  "detail.subscribeShare": "🎚️ Subscribe Share",
  "detail.customShare": "Custom Share",
  "detail.remainingShare": "Remaining Share",
  "detail.shareMsg":
    "The subscription ratio cannot exceed the remaining {n}% compute value",
  "detail.incomeDetail": "📈 Estimated Income Details",
  "detail.incomeTip":
    "Estimated income is for reference only. Actual income is based on settlement data",
  "detail.estimate": "Estimate",
  "detail.rate": "Yield:",
  "detail.settleDate": "Settlement Date:",
  "detail.moreStages": "{count} more phases",
  "detail.hoverExpand": "Hover to expand",
  "detail.totalIncome": "Estimated Total Income",
  "detail.fundDetail": "💰 Fund Details",
  "detail.rentalAmount": "Rental Amount",
  "detail.maintenanceFee": "Maintenance Fee",
  "detail.feeFormula": "Total Value*{percent}%*{fee}%",
  "detail.tierDiscount": "Tier Discount",
  "detail.subscribeTip": "(Subscribe {percent}%)",
  "detail.discountDetail": "🎯 Discount Tier Details",
  "detail.subscribeGte": "Subscribe ≥ {percent}%",
  "detail.currentSubscribe":
    "Current subscription {percent}%, discount -${discount}",
  "detail.total": "Total",
  "detail.btnFull": "⏳ Full",
  "detail.btnEnded": "⏳ Ended",
  "detail.btnPending": "⏳ Not Started",
  "detail.btnRent": "🚀 Rent Now",
  "detail.btnOutOfStock": "⏳ Temporarily Out of Stock",
  "detail.guaranteeSupport": "7×24 Customer Support",
  "detail.guaranteeData": "Data Security",
  "detail.guaranteeSla": "99.9% SLA",
  "detail.recommendBadge": "🔄 You May Also Like",
  "detail.recommendTitle1": "Recommended",
  "detail.recommendTitle2": "Servers",
  "detail.recValue": "Value",
  "detail.recDetail": "View Details →",
  "detail.faqBadge": "❓ FAQ",
  "detail.faqTitle1": "Rental",
  "detail.faqTitle2": "FAQ",
  "detail.chartModalTitle": "📈 Income Trend Chart",
  "detail.spec0": "Entry",
  "detail.spec1": "Light",
  "detail.spec2": "Performance",
  "detail.spec3": "Flagship",
  "detail.spec4": "Ultra Flagship",
  "detail.faq1Q": "Do I need a deposit to rent a server?",
  "detail.faq1A":
    "For first-time users, we may charge a certain percentage as a deposit. Long-term partners can enjoy deposit reduction policies. The specific amount is based on the settlement page.",
  "detail.faq2Q": "How do I renew after the rental expires?",
  "detail.faq2A":
    "You can renew in the 'My Rentals' page in the console. Supports daily, weekly, monthly, and quarterly renewal at the same price as the current rental.",
  "detail.faq3Q": "What if the server malfunctions?",
  "detail.faq3A":
    "We provide 7×24 technical support. In case of hardware failure, we will respond within 2 hours and complete repair or replacement within 24 hours.",
  "detail.faq4Q": "Can I terminate the rental early?",
  "detail.faq4A":
    "Yes. Early termination requires paying 30% of the remaining rental period as a penalty. Please read the 'Rental Service Agreement' carefully when renting.",
  "detail.faq5Q": "How is data security ensured for rented servers?",
  "detail.faq5A":
    "We use enterprise-grade data encryption. All data is encrypted during transmission and storage. After the rental ends, your data will be completely erased.",
  "detail.unitWan": "K",
  "detail.msgOutOfStock": "This server is temporarily out of stock",
  "detail.msgSelectShare": "Please select a subscription share",
  "detail.msgRentFail": "Rental failed",
  "detail.msgRentSuccess": "Rental successful",
  "detail.msgContact": "Contact support: 400-888-8888",
  "detail.pwdTitle": "Rental Confirmation",
  "detail.pwdLabel": "Enter trading password",
  "detail.pwdPlaceholder": "Enter trading password",
  "detail.pwdConfirm": "Confirm Rental",
  "detail.pwdCancel": "Cancel",
  "detail.rentNow": "💎 Rent Now",
  "detail.rentAmount": "Rental Amount",
  "detail.subscribe": "Subscribe",
  "detail.descProduct": "Product Description",
  "detail.descRegion": "Region Info",
  "detail.rentNowBtn": "🚀 Rent Now",
  "detail.outOfStock": "⏳ Temporarily Out of Stock",
  "detail.stages": "phases",
  "detail.discount": "Discount",
  "detail.rentConfirm": "Rental Confirmation",
  "detail.enterPassword": "Enter trading password",
  "detail.confirmRent": "Confirm Rental",
  "detail.cancel": "Cancel",
  "detail.rentyunxz": "Running",
  "detail.outOfStockMsg": "This server is temporarily out of stock",
  "detail.selectShareMsg": "Please select a subscription share",
  "detail.rentFail": "Rental failed",
  "detail.rentSuccess": "Rental successful",
  "detail.contactService": "Contact support: 400-888-8888",
  "detail.tenThousand": "K",

  // ===== Compute Info Page =====
  "info.emptyTitle": "No compute servers available",
  "info.emptyDesc":
    "Coming soon. We are working hard to prepare more quality compute resources for you",
  "info.collapse": "Collapse",
  "info.expand": "Expand",
  "info.collapseDetail": "Collapse Details",
  "info.expandDetail": "Expand Details",
  "info.priceTrend": "📈 Price Trend",
  "info.docsTitle": "📄 Overview",
  "info.unit": "Unit",
  "info.latestPrice": "Latest Price",
  "info.lastPrice": "Yesterday's Price",
  "info.increase": "Increase",
  "info.buyNow": "Buy Now",
  "info.buyCompute": "Buy Compute",
  "info.selectPeriod": "Select Period",
  "info.day": "days",
  "info.periodTime": "Period Time",
  "info.purchaseQuantity": "Purchase Quantity",
  "info.expectedProfit": "Estimated Income",
  "info.profitTip":
    "Estimated income is based on historical averages. Actual income is based on settlement data",
  "info.baseProfit": "Basic Income",
  "info.settle24h": "24h Settlement",
  "info.periodProfit": "Period Income",
  "info.settleDue": "Due Settlement",
  "info.totalProfit": "Total Income",
  "info.fundDetail": "Fund Details",
  "info.purchaseAmount": "Purchase Amount",
  "info.buyFormula": "Latest Price x Quantity",
  "info.fee": "Fee",
  "info.feeFormula": "Purchase Amount*{fee}%",
  "info.total": "Total",
  "info.cancel": "Cancel",
  "info.confirmBuy": "Confirm Purchase",
  "info.tradeConfirm": "Trade Confirmation",
  "info.enterPassword": "Enter trading password",
  "info.confirmPay": "Confirm Payment",
  "info.chart7d": "7D",
  "info.chart15d": "15D",
  "info.chart30d": "30D",
  "info.price": "Price",
  "info.maxValue": "Max Value",
  "info.noData": "No data",
  "info.fetchFail": "Failed to fetch data",
  "info.selectProduct": "Please select a product first",
  "info.quantityMin": "Purchase quantity cannot be less than 1",
  "info.priceError": "Current price is abnormal, please try again later",
  "info.buySuccess": "Purchase successful!",
  "info.tradeFail": "Transaction failed, please try again later",
  "info.passwordError": "Trading password incorrect, please re-enter",
  "info.buyFail": "Purchase failed, please try again later",

  // ===== About Us Page =====
  "about.tocTitle": "📑 Table of Contents",
  "about.toc1": "Mastering Digital Gold",
  "about.toc2": "Core Product Matrix",
  "about.toc3": "Aetrivol Security & Reliability",
  "about.toc4": "Investment Value",
  "about.section1Title":
    "Mastering Digital Gold: Becoming the 'Super New Compute Power Lord' of the Intelligent Era",
  "about.section1P1":
    "As global large models enter trillion-parameter battles and embodied intelligence fully explodes, compute power has completely replaced oil as the ultimate hard currency dominating world wealth. Tech giants are frantically hoarding GPUs at any cost, and data centers costing hundreds of millions shut out ordinary investors. Aetrivol was born to meet the times. Through our innovative compute value anchoring mechanism and compute server rental model, we break asset monopolies and let you directly enjoy the greatest wealth compounding feast in human history in the simplest, most flexible way.",
  "about.section2Title": "Core Product Matrix: Dual-Driven Wealth Engine",
  "about.section2H1":
    "Innovative Product 1: [Compute Value (CV)] — 'Tokenized Dividends' of Global Compute Assets",
  "about.section2P1":
    "· Breaking Barriers, Micro-Assetization: We standardize and split the overall compute power of global physical data centers and high-end GPU servers (NVIDIA Blackwell, Huawei Ascend, etc.). 1 point of [Compute Value] represents your ownership of a specific share of compute power in the global compute network.",
  "about.section2P2":
    "· Buy GPU Like Buying a Fund: With a minimum small investment to subscribe [Compute Value], you can break the barrier of 'hard to get a card'. Your compute value runs 24/7 on the platform, earning daily digital cash flow dividends from AI large models and agent calls worldwide.",
  "about.section2P3":
    "· High Liquidity, Cash Out Anytime: Compute value has extremely strong asset liquidity. As global compute demand surges, compute value itself has high premium potential. You can trade and cash out anytime on the platform.",
  "about.section2H2":
    "Core Business 2: [Compute Server Leasing] — The Stable Long-Term 'Digital Landlord' Model",
  "about.section2P4":
    "· Physical Asset Subscription, Exclusive Server Ownership: Investors can directly subscribe to entire servers or standard racks of compute servers under the platform. Each server is truly mapped on-chain with a unique physical SN code.",
  "about.section2P5":
    "· Long-Term Managed Leasing, Stable High Rent: After subscription, servers are directly hosted in the platform's top-tier data centers at global green compute hubs (such as China's Western East-Data-West-Computing nodes, Northern Europe, Middle East, etc.). The platform leases your servers to large model developers, university research institutes, or vertical AI companies in need of compute power, locking in 3-5 year stable high-return leases.",
  "about.section3Title": "Why Can Aetrivol Turn Risk into Absolute Certainty?",
  "about.section3P1":
    "· 100% Physical Asset On-Chain Anchoring: We refuse castles in the air. Whether it's the compute value you hold or the servers you rent, they are all mapped in real-time on-chain to physical accelerator hardware that is online and humming. Assets are visible, tangible, and verifiable.",
  "about.section3P2":
    "· Top-Tier Energy Efficiency and 'Anti-Geopolitical' Double Insurance: The data centers we package are 100% equipped with 'micro nuclear (SMR)/solar direct power supply' or located in absolutely safe non-conflict legal jurisdictions, completely avoiding the risks of global local grid tsunamis and geopolitical fluctuations.",
  "about.section3P3":
    "· Giant Credit Endorsement and Long-Term Contract Guarantee: The platform prioritizes mature sites pre-locked for leasing by AI giants like Microsoft, OpenAI, and DeepSeek, using tech giants' credit as endorsement for your returns.",
  "about.section4Title":
    "In the past, they invested in land and oil; today, we invest in compute power.",
  "about.section4P1":
    "As all human wisdom and business migrate to the digital world, compute power is the only building material of this new world. Join Aetrivol, purchase your compute value, and start your compute server rental journey. Convert your capital into compute atoms that reshape the world and share in this wealth surge of intelligent explosion!",

  agreement: agreementContent,

  "withdraw.insufficientHandlingFee": "Insufficient handling fee",
  "withdraw.twoFactor":
    "You have not enabled two-factor authentication, so you cannot withdraw. Please enable two-factor authentication first.",
  "bindAddress.twoFactor":
    "You have not enabled two-factor authentication, so you cannot bind the address. Please enable two-factor authentication first.",
  "productServer.statusPending": "Pending",
  "historyToken.add": "Add Funds",
  "serverServer.serverover": "Settlement Date",

  "walletLog.statusPeriodIncome": "Periodic Income",
  "productToken.statusOver": "Ended",
  "productServer.phaseDate": "Settlement Date",

  // ===== 认证审核通过页（Approved） =====
  "approved.back": "Back",
  "approved.title": "Application Approved",
  "approved.subtitle": "Congratulations! Your verification documents have been approved.",
  "approved.benefitsTitle": "🎉 You now enjoy the following benefits",
  "approved.benefit1": "Full access to all features",
  "approved.benefit2": "Early access to new features",
  "approved.benefit3": "Dedicated customer support",
  "approved.benefit4": "More permissions unlocked",
  "approved.login": "Log in to your account",

  // ===== 认证审核中页（Review） =====
  "review.back": "Back",
  "review.title": "Under Review",
  "review.subtitle": "Your verification documents are being reviewed. Please wait patiently.",
  "review.step1": "Submit Documents",
  "review.step2": "Under Review",
  "review.step3": "Completed",
  "review.estimatePrefix": "Estimated review time: ",
  "review.estimateDefault": "Within 24 hours",
  "review.notifyByEmail": "The review result will be sent to your email",
  "review.keepContact": "Please keep your phone reachable to receive notifications",

  "productToken.timeover": "Expiration Time",

  // ===== Customer Service Chat =====
  "chat.title": "Online Support",
  "chat.connected": "Connected",
  "chat.connecting": "Connecting…",
  "chat.empty": "No messages yet, feel free to start a conversation",
  "chat.placeholder": "Type your message…",
  "chat.send": "Send",
  "chat.sending": "Sending",
  "chat.image": "Send image",
  "chat.read": "Read",
  "chat.sent": "Sent",
  "chat.sendFailed": "Failed to send, please retry",
  "chat.sessionFailed": "Failed to load the conversation, please retry",
  "chat.uploading": "Uploading…",
  "chat.uploadFailed": "Upload failed",
  "chat.imageTooLarge": "Image must be smaller than 5MB",
  "chat.kicked": "Session expired, please log in again",
  "chat.recall": "Recall",
  "chat.recallConfirm": "Recall this message?",
  "chat.recallFailed": "Failed to recall, please retry",
  "chat.recalledSelf": "You recalled a message",
  "chat.recalledPeer": "The other party recalled a message",
  "chat.typingPeer": "Support is typing…",
  "chat.confirm": "Confirm",
  "chat.cancel": "Cancel",

  // ===== About page (v2) =====
  "aboutPage.tocTitle": "📑 Table of Contents",
  "aboutPage.toc1": "About Us",
  "aboutPage.toc2": "Core Team",
  "aboutPage.toc3": "Global Offices",
  "aboutPage.s1Title": "About Us",
  "aboutPage.s1P1": "Aetrivol is a core compute platform built for the global digital economy and deeply engaged in artificial-intelligence infrastructure. Amid the surge of generative AI and deep learning, Aetrivol has closed the loop between compute assetization and commercial server leasing through a forward-looking global data-center footprint and a powerful engineering foundation. As one of the very few platforms able to directly empower world-leading AI research and commercial deployment, Aetrivol now processes average daily trading volume of over US$1 billion. This not only demonstrates unmatched liquidity and market trust, but also cements its leading position as the global distribution hub for AI compute.",
  "aboutPage.s1P2": "Today, a high-end AI data center costs hundreds of millions, and the supply-demand imbalance for GPU servers is extreme.",
  "aboutPage.s1L1": "Capital barrier: ordinary investors cannot join the primary-market hardware pool directly.",
  "aboutPage.s1L2": "Demand catalyst: large-model and AI agent invocations are growing exponentially.",
  "aboutPage.s1L3": "Real-estate logic: premium compute resources show the rent-collecting nature of “prime-location property”.",
  "aboutPage.s1P3": "Facing this compute monopoly, the solution proposed by Aetrivol is rebuilding the balance sheets of global investors. Its core value lies in turning “inaccessible hard tech” into “easy-to-allocate liquid assets”.",
  "aboutPage.s1Stat1Label": "Average Daily Trading Volume",
  "aboutPage.s1Stat1Value": "US$1B+",
  "aboutPage.s1Stat2Label": "Data Center Tier",
  "aboutPage.s1Stat2Value": "Tier 4",
  "aboutPage.s1Stat3Label": "Uptime (SLA)",
  "aboutPage.s1Stat3Value": "99.99%",
  "aboutPage.s1H2a": "Core Business Matrix: Two Engines of Value Growth",
  "aboutPage.s1H3a": "1. Compute Value Investment (Computing Power Tokenization)",
  "aboutPage.s1P4": "Aetrivol converts traditional, high-threshold hardware compute into “Compute Value” assets that are quantifiable, divisible and highly liquid.",
  "aboutPage.s1L4": "Asset accessibility: investors bear no server operations, depreciation or heavy electricity costs — allocating Compute Value directly anchors them to the core growth of the global AI industry.",
  "aboutPage.s1L5": "Intelligent compounding returns: Compute Value returns are deeply tied to the real operating efficiency of the underlying servers and to dynamic market supply and demand. A proprietary dynamic pricing algorithm delivers steady yet explosive intelligent returns.",
  "aboutPage.s1H3b": "2. High-Performance Server Leasing (Enterprise Server Leasing)",
  "aboutPage.s1P5": "Aetrivol operates cutting-edge Tier 4 green data centers around the world, offering leasing services for industrial-grade GPUs (NVIDIA H100, B200 series, etc.) and customized ASIC chip clusters.",
  "aboutPage.s1L6": "Instant deployment and elastic scaling: microsecond-level compute scheduling for enterprise clients, supporting everything from single-machine R&D to large-scale parallel training on 10,000-GPU clusters.",
  "aboutPage.s1L7": "Mature sites backed by tech giants: every Aetrivol core site has passed extremely rigorous industrial-grade stress testing. Today, a large number of mature Aetrivol compute sites have been pre-booked and leased long-term by the world's leading model giants such as Microsoft, OpenAI and DeepSeek. Their presence not only creates long-term, stable cash flow, but also serves as the ultimate endorsement of the platform's technical stability and compliance.",
  "aboutPage.s1H2b": "Distinctive Advantages: Scarcity and Security Moats",
  "aboutPage.s1L8": "Certainty premium locked in by giants: because industry leaders such as Microsoft, OpenAI and DeepSeek lease Aetrivol's underlying compute on long-term charters, the platform's assets are highly resilient with an almost zero idle rate, forming a natural value moat.",
  "aboutPage.s1L9": "Military-grade security and elite operations: proprietary compute virtualization isolation technology plus round-the-clock automated inspection keep data privacy and computing tasks absolutely secure, with uptime (SLA) of 99.99%.",
  "aboutPage.s1L10": "Outstanding liquidity: average daily trading volume of up to US$1 billion ensures compute assets can circulate and be cashed out at extreme speed within the platform and its ecosystem.",
  "aboutPage.s1H2c": "Conclusion: Partner with the Era's Navigator",
  "aboutPage.s1P6": "AI ends in compute. Holding the pulse of the era, Aetrivol is becoming the shared choice of global tech giants and top-tier capital through monopolistic integration of scarce compute resources and an innovative assetization model. Here you invest not only in servers, but in a ticket to the golden age of artificial intelligence.",
  "aboutPage.s2Title": "Core Team",
  "aboutPage.s2Group1": "Board of Directors – Core Members",
  "aboutPage.s2Group2": "Chief Executive Officer (CEO)",
  "aboutPage.s2Group3": "Chief Technology Officer (CTO)",
  "aboutPage.s2Group4": "Chief Scientist",
  "aboutPage.s2Group5": "Department Heads",
  "aboutPage.s2BioLabel": "Career highlights: ",
  "aboutPage.s2Role1": "Chairman of the Board & Chair of the Safety and Ethics Committee",
  "aboutPage.s2Bio1": "Co-founder and CEO of OpenAI. Former President of Y Combinator.",
  "aboutPage.s2Role2": "Director of Strategy & Ecosystem Collaboration",
  "aboutPage.s2Bio2": "Chairman and CEO of Microsoft. He is the most capable operator in modern corporate strategy, alliance building and top-level multinational governance.",
  "aboutPage.s2Role3": "Scientific Advisor & Independent Non-Executive Director",
  "aboutPage.s2Bio3": "Professor Emeritus at the University of Toronto, winner of the 2024 Nobel Prize in Physics and the Turing Award, known as the “Godfather of Deep Learning”.",
  "aboutPage.s2Bio4": "Founder of Google DeepMind, winner of the 2024 Nobel Prize in Chemistry.",
  "aboutPage.s2Bio5": "She served as OpenAI's CTO for years and was a core engineer on the Tesla Model X. At OpenAI she led the complex engineering delivery of ChatGPT, DALL·E and GPT-4o.",
  "aboutPage.s2Bio6": "Co-founder of Safe Superintelligence (SSI), former co-founder and Chief Scientist of OpenAI.",
  "aboutPage.s2Role7": "VP of Compute Infrastructure",
  "aboutPage.s2Bio7": "Former Chief Design Officer at Apple. He designed the iPhone, iMac and iPad and is renowned worldwide in the design field.",
  "aboutPage.s2Role8": "Director of Frontier AI & Open-Source Ecosystem",
  "aboutPage.s2Bio8": "Chief AI Scientist at Meta, Turing Award winner.",
  "aboutPage.s2Role9": "CPO of Consumer Products & Ecosystem",
  "aboutPage.s2Bio9": "CEO of Microsoft AI. Co-founder of DeepMind and founder of Inflection AI.",
  "aboutPage.s3Title": "Global Offices",
  "aboutPage.s3MapTitle": "Global Office Network",
  "aboutPage.s3MapHint": "Hover over a location pin on the map to preview the office address — click to keep it pinned",
  "aboutPage.s3Country1": "United States",
  "aboutPage.s3Addr1": "12015 Waterfront Dr, Los Angeles, CA 90094",
  "aboutPage.s3Country2": "Singapore",
  "aboutPage.s3Addr2": "438B Alexandra Rd, Alexandra Technopark, Singapore 119968",
  "aboutPage.s3Country3": "Qatar",
  "aboutPage.s3Addr3": "Innovation Centre, Al Luqta St, Education City, Doha, Qatar",
  "aboutPage.s3Country4": "France",
  "aboutPage.s3Addr4": "5 Parvis Alan Turing, 75013 Paris, France",

  // Activity
  "activity.passwordTitle": "Pre-order Password",
  "activity.passwordTip": "This pre-order is password protected. Enter the activity password to continue.",
  "activity.passwordPlaceholder": "Enter 10-character password",
  "activity.passwordRequired": "Please enter the activity password",
  "activity.passwordError": "Incorrect activity password",
  "activity.cancel": "Cancel",
  "activity.confirm": "Confirm",
  "activity.preorderTitle": "Server Rental Pre-order",
  "activity.discountTitle": "Tier Discounts",
  "activity.discountRule": "Spend ${amount} get {percent}% off",
  "activity.discountHit": "Applied",
  "activity.selectShare": "Select Share",
  "activity.remainingShare": "Remaining Share",
  "activity.originAmount": "Original Amount",
  "activity.discountAmount": "Discount",
  "activity.serviceFee": "Service Fee",
  "activity.payTotal": "Total Payable",
  "activity.payNow": "Pay Now",
  "activity.tradeTitle": "Confirm Payment",
  "activity.tradeLabel": "Enter trade password",
  "activity.loadFail": "Failed to load activity",
  "activity.cannotBuy": "This pre-order is no longer available",
  "activity.minShare": "Minimum share is {percent}%",
  "activity.payFail": "Payment failed, please try again",
  "activity.paySuccess": "Pre-order successful",
  "activity.tokenTitle": "Computing Power Activity",
  "activity.ongoing": "Ongoing",
  "activity.completed": "Completed",
  "activity.rewardCountry": "Country",
  "activity.rewardPeriod": "Period",
  "activity.days": "days",
  "activity.rewardPercent": "Share",
  "activity.rewardTime": "Payout",
  "activity.rewardUsers": "Users",
  "activity.rewardShares": "Issued",
  "activity.tokenDesc1": "During settlement, we sum all computing power shares you hold across every period in {country}, and reward {percent}% of that total as new shares.",
  "activity.tokenDesc2": "Rewards are issued automatically at {time} in the selected {period}-day period product, and start generating income immediately.",
  "activity.tokenDesc3": "Reward shares are free of principal charge; income is settled according to the product's normal rules.",
  "activity.gotIt": "Got it",
};
